import TicketWidget from "@/widget";

document.cookie = "ticket_widget_demo_user=demo-user-42; path=/; SameSite=Lax";

TicketWidget.mount("#ticket-widget", {
  eventId: "demo-event",
  apiBaseUrl: "https://ticket-widget.dev2.mind4.me",
  accessToken: "secret-api-token",
  locale: "ru-RU",
  currency: "RUB",
  onOrderCreated: (order) => {
    console.info("Ticket widget order created:", order);
  },
});
